import { cn } from '@hap/components'

import { useUploadContext } from './hooks'

const stages = ['upload', 'import', 'transcribe', 'analyze'] as const

const stageLabels: Record<(typeof stages)[number], string> = {
  upload: 'Uploading...',
  import: 'Importing...',
  transcribe: 'Transcribing...',
  analyze: 'Analyzing...',
}

interface ImportStageBarProps {
  size?: 'sm' | 'md'
  showLabel?: boolean
  className?: string
}

export function ImportStageBar({
  size = 'sm',
  showLabel = false,
  className,
}: ImportStageBarProps) {
  const { furthestStage, hasErrors } = useUploadContext()
  if (!furthestStage) return null

  const currentIndex = stages.indexOf(
    furthestStage === 'done' ? 'analyze' : furthestStage,
  )

  const segmentSize = size === 'sm' ? 'h-1.5 grow' : 'h-2 grow'

  return (
    <span className={cn('flex items-center gap-2', className)}>
      {showLabel && furthestStage !== 'done' && (
        <span>
          <span>{stageLabels[furthestStage]}</span>
        </span>
      )}
      <span className="flex shrink grow items-center gap-px">
        {stages.map((stage, i) => {
          const isCompleted = i < currentIndex
          const isActive = i === currentIndex && furthestStage !== 'done'

          return (
            <span
              key={stage}
              className={cn(
                'transition-colors duration-500',
                segmentSize,
                isCompleted && 'bg-primary',
                isActive && !hasErrors && 'bg-primary animate-pulse',
                isActive && hasErrors && 'bg-destructive',
                !isCompleted && !isActive && 'bg-muted',
              )}
            />
          )
        })}
      </span>
    </span>
  )
}
